// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1V-wk","title":"Info_title__UMcfA","selects":"Info_selects__2U4M-","requiredAsterisk":"Info_requiredAsterisk__3ua8F"};